import { OrdersApi } from "@idha/idha-api/dist/orders/OrdersApi";
import { ORDERS_URL } from "./apiUrls";

const ordersApi = new OrdersApi({
    baseUrl: ORDERS_URL,
    transformRequest: (data,headers) => {
        headers['Authorization'] = headers['Authorization'] || window.localStorage.getItem('$LoopBack$accessTokenId')

        return JSON.stringify(data)
    },
     interceptors: {
        response: [
            {
                onRejected: (e) => {
                    if (e?.response?.data?.error?.status == 400 &&
                            e?.response?.data?.error?.message) {
                        alert(e?.response?.data?.error?.message)
                    } else {
                        alert(`Houve um erro desconhecido. Contacte o suporte idha`)
                    }
                    
                }
            }
        ]
    }
})

export {ordersApi}